var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.dataTag,{tag:"component",class:['TableCellCmp', 'a-paragraph-2']},[(_vm.dataValue)?[_vm._v(" "+_vm._s(_vm.customDecimalSeparator(_vm.dataValue, _vm.$store.state.config.decimal_separator))+" ")]:[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }